import { store } from '../../../store/index';
import { addActiveLayer } from '../../../store/slices/zIndexLayerSlice';

let globalDispatch = null;

function getDispatch() {
  return globalDispatch;
}

export function initLayerService(dispatch) {
  globalDispatch = dispatch;
}

export function zIndexLayer(layerName) {
  const dispatch = getDispatch();
  dispatch(addActiveLayer(layerName));
  const zIndex = store.getState().zIndex.currentZIndex;

  return zIndex;
}
